export class StatusMsg {
  httpStatusCode:number;
  statusMsg:string;
}
